import { ApostleBase, ApostleSkillExp } from '@apeiron/apostle'
import { Box, styled } from '@mui/material'
import ApostleSkillCard from '@src/components/apostles/card/ApostleSkillCard'
import * as R from 'ramda'
import { FC } from 'react'

const Container = styled(Box)`
  display: flex;
  gap: 2px;
  justify-content: flex-start;
  width: calc(100% - 8px);
`

const StyledApostleSkillCard = styled(ApostleSkillCard)`
  width: 20%;
`

const ApostleCardSkillList: FC<Props> = props => {
  const { className, apostle } = props

  if (apostle) {
    return (
      <Container className={className}>
        {R.map((skillExp: ApostleSkillExp) => {
          return (
            <StyledApostleSkillCard
              key={skillExp.key}
              skillExp={skillExp}
              className='Custom-Apostle-Skill-Card'
            />
          )
        }, apostle.skillExps)}
      </Container>
    )
  } else return null
}

type Props = {
  apostle?: ApostleBase
  className?: string
}

export default ApostleCardSkillList
